import React, { useState } from "react";
import objectToFormData from "object-to-formdata";

const Form = props => {
	const [info, changeInfo] = useState({
		// Tells /api/contact which field/label map to use.
		form: "calculator",
		// Honeypot: stays empty for real people, filled by bots.
		company: "",
		"service-type": "iOS programėlė",
		"about-project": "",
		"calculated-price": props.price,
		email: "",
		file: {}
	});
	const [contactResponse, changeContactResponse] = useState({
		success: false,
		message: ""
	});

	const display = {
		display: "flex",
		flexDirection: "row"
	};

	function handleTextChange(e) {
		e.preventDefault();
		changeInfo({ ...info, "about-project": e.target.value });
	}

	function handleEmailtChange(e) {
		e.preventDefault();
		changeInfo({ ...info, email: e.target.value });
	}

	function handleOptionSelect(e) {
		e.preventDefault();
		changeInfo({ ...info, "service-type": e.target.value });
	}

	function handleFileChange(e) {
		changeInfo({
			...info,
			file: e.target.files[0]
		});
	}

	async function handleSubmit(e) {
		e.preventDefault();

		// Posts to the Next.js site's shared mail endpoint. Spam is handled by
		// the honeypot field plus per-IP rate limiting on the server, so there
		// is no captcha script to load here.
		const payload = { ...info };
		if (!payload.file || !payload.file.name) delete payload.file;

		try {
			const response = await fetch("/api/contact", {
				method: "POST",
				body: objectToFormData(payload, { indices: true })
			});
			const body = await response.json().catch(function() { return null; });

			if (response.ok && body && body.ok) {
				changeContactResponse({
					success: true,
					message: "Ačiū! Jūsų užklausą gavome - atsakysime per 24 valandas darbo dienomis."
				});
			} else {
				changeContactResponse({
					success: false,
					message:
						(body && body.error) ||
						"Įvyko klaida siunčiant žinutę. Prašome pabandyti vėliau."
				});
			}
		} catch (err) {
			changeContactResponse({
				success: false,
				message:
					"Nepavyko susisiekti su serveriu. Patikrinkite ryšį ir bandykite dar kartą."
			});
		}
	}

	return (
		<div id="contact-form" className="form">
			<div className="ideaTitle">[Papasakokite apie savo idėją]</div>

			<span className="line" />

			<form
				onSubmit={handleSubmit}
				className="wufoo topLabel page1"
				autoComplete="off"
				encType="multipart/form-data"
				method="post"
				action="/api/contact"
			>
				<ul>
					<li aria-hidden="true" style={{ position: "absolute", left: "-9999px", width: 1, height: 1, overflow: "hidden" }}>
						<label htmlFor="calc-company">Įmonė</label>
						<input
							id="calc-company"
							name="company"
							type="text"
							tabIndex={-1}
							autoComplete="off"
							onChange={function(e) { changeInfo({ ...info, company: e.target.value }); }}
						/>
					</li>
					<li>
						<div className="form-group">
							<label className="desc notranslate">
								Paslaugos tipas
							</label>
							<div>
								<select
									onChange={handleOptionSelect}
									id="service-type"
									name="service-type"
									className="field select large"
									required={true}
								>
									<option value="iOS programėlė">
										iOS programėlė
									</option>
									<option value="Android programėlė">
										Android programėlė
									</option>
									<option value="iOS ir Android">
										iOS ir Android
									</option>
									<option value="WEB projektas">
										WEB projektas
									</option>
									<option value="Nestandartinis projektas">
										Nestandartinis projektas
									</option>
								</select>
							</div>
						</div>
					</li>

					<li>
						<div className="form-group">
							<label className="desc">
								Papasakokite apie savo projektą
								<span className="req">*</span>
							</label>
							<div>
								<textarea
									value={info.text}
									onChange={handleTextChange}
									id="about-project"
									name="about-project"
									className="form-control"
									rows="7"
									required={true}
								/>
							</div>
						</div>
					</li>
					<div style={display}>
						<li className="inline">
							<div className="form-group">
								<label className="desc">
									El. paštas
									<span className="req">*</span>
								</label>
								<div className="emailInput">
									<input
										onChange={handleEmailtChange}
										value={info.email}
										id="email"
										name="email"
										type="email"
										className="field text large form-control"
										required={true}
									/>
								</div>
							</div>
						</li>

						<li className="inline">
							<div className="form-group">
								<label className="desc">
									Pridėti failą (10mb; DOC, PDF)
								</label>
								<div>
									<label className="field file large">
										<div className="file-name-text">
											<div data-field="choose-file-text">
												Pasirinkti failą
											</div>
											<div
												className="cut-text"
												data-field="choose-file-file-name"
												style={{ display: "none" }}
											/>
										</div>
										<input
											onChange={handleFileChange}
											data-field="choose-file-input"
											name="file"
											id="file"
											type="file"
											className="hide-input"
											data-filesize="10240"
											accept=".doc,.docx,.pdf"
											data-accept=".doc,.docx,.pdf"
											data-error="Failo formatas arba dydis yra netinkamas (Tinka pdf, doc, docx) (maks 10mb.)"
										/>
										<div className="help-block with-errors" />
									</label>
								</div>
							</div>
						</li>
					</div>

					<div
						style={{
							color: contactResponse.success ? "green" : "red"
						}}
					>
						{contactResponse.message === ""
							? ""
							: contactResponse.message}
					</div>

					<li className="buttons">
						<div>
							<input
								name="send"
								className="btTxt submit disabled"
								type="submit"
								value="Siųsti"
							/>
						</div>
					</li>
				</ul>
			</form>
		</div>
	);
};

export default Form;
